import React from 'react';
import styles from './base-calendar.module.scss';
import { CalendarView, MoveProps } from '../../types';
import classNames from 'classnames';
import moment from 'moment';
import { IconButton } from '@mui/material';
import { SVGS } from '../../../../../assets/images';
import { getSecondDate } from '../../utils';

interface Props {
    activeDate: moment.Moment;
    doubled: boolean;
    onSwitch: (move: MoveProps) => void;
    view: CalendarView;
    small?: boolean;
    minDate?: moment.Moment;
    maxDate?: moment.Moment;
    disableSwitch?: boolean;
}

const getFormatForDate = (view: CalendarView) => {
    switch(view) {
        case 'month':
            return 'MMMM YYYY';
        case 'year': 
            return 'YYYY'
    }
}

export const NavigationLabel = (props: {
    date: moment.Moment;
    view: CalendarView;
    small?: boolean;
}) => {
    const { date, view, small } = props;
    const formatDate = getFormatForDate(view);


    return(<h6 className={classNames({
        [styles.name]: true,
        [styles.small]: small
    })}>{date.format(formatDate)}</h6>)
}

export default function CalendarNavigation(props: Props) {
    const { activeDate, onSwitch, view, doubled, small, disableSwitch, minDate, maxDate } = props;
    const secondDate = getSecondDate(view, activeDate);
    const leftSwitchDisabled = (minDate && minDate.diff(activeDate, 'month') >= 0) || false;
    const rightSwitchDisabled = (maxDate && maxDate.diff(activeDate, 'month') < 1) || false;
    
    return(<div className={classNames({
        [styles.selector]: true,
        [styles.stretch]: !disableSwitch
    })}>
        { 
            !disableSwitch && <IconButton
                className={classNames({
                    [styles.switchButton]: true,
                    [styles.small]: small
                })}
                onClick={() => onSwitch('decrease')}
                disabled={leftSwitchDisabled}>
                <SVGS.LeftChevronIcon />
            </IconButton> 
        }
        <button className={classNames({
            [styles.nameButton]: true,
            [styles.double]: doubled
        })}>
            <NavigationLabel 
                date={activeDate} 
                view={view} 
                small={small} />
            {
                doubled && <NavigationLabel 
                    date={secondDate} 
                    view={view} 
                    small={small} />
            }
        </button>
        { 
            !disableSwitch && <IconButton
                className={classNames({
                    [styles.switchButton]: true,
                    [styles.small]: small
                })}
                onClick={() => onSwitch('increase')}
                disabled={rightSwitchDisabled}>
                <SVGS.RightChevronIcon />
            </IconButton>
        }
    </div>)
}